import {
  DISMISS_ONBOARDING,
  CREATE_CHART,
} from '../../components/HighlightFeature';
import { BAR, LINE, PIE } from '../../components/charting/chartType.constants';

// actions: an object like {actionName: true}
// targetAction: a string matching the actions in the db, or NULL
// requiredActions: an array of actions, or NULL.
export function showOnboarding(actions, targetAction, requiredActions = []) {
  // always show onboarding with no way to dismiss e.g. for dashboard add-saved-query.
  if (!targetAction) {
    return true;
  }

  if (!actions) {
    return false;
  }

  // targetAction can be a simple string or an array of strings. If any of them have been done or dismissed, don't show onboarding.
  const actionComplete = Array.isArray(targetAction)
    ? targetAction.some((tA) => actions[tA])
    : actions[targetAction];

  const actionDismissed = Array.isArray(targetAction)
    ? targetAction.some((tA) => actions[DISMISS_ONBOARDING + tA])
    : actions[DISMISS_ONBOARDING + targetAction];

  // if actions haven't loaded yet, or target action is already complete or dismissed, don't show anything.
  if (
    actionComplete ||
    actionDismissed ||
    (targetAction === CREATE_CHART && userCreatedChart(actions))
  ) {
    return false;
  }

  // user has completed the required actions
  const requiredActionsComplete =
    !requiredActions || requiredActions.length === 0
      ? true // no required actions and target action hasn't been completed, so show.
      : requiredActions.every((requiredAction) => {
          if (requiredAction === CREATE_CHART) {
            return userCreatedChart(actions);
          }
          return (
            actions[requiredAction] ||
            actions[DISMISS_ONBOARDING + requiredAction]
          );
        });

  // show onboarding if the action is not dismissed and the required actions are complete
  if (requiredActionsComplete) {
    return true;
  }
  return false;
}

// user has toggled one of the chart options
function userCreatedChart(actions) {
  const BAR_ACTION = CREATE_CHART + BAR;
  const PIE_ACTION = CREATE_CHART + PIE;
  const LINE_ACTION = CREATE_CHART + LINE;
  return actions[BAR_ACTION] || actions[PIE_ACTION] || actions[LINE_ACTION];
}
